import isArray from 'lodash.isarray';
import isObject from 'lodash.isobject';

// eslint-disable-next-line
export const buildObjectPath = (obj: any) => {
  const path = [obj.$$$nodeName];
  let node = obj.$$$parentNode;
  while (node && node.$$$parentNode) {
    path.push(node.$$$nodeName);
    node = node.$$$parentNode;
  }
  return path.reverse().join('.').replace('.[', '[');
};

// eslint-disable-next-line
export const addObjectParentReferences = (parent: any, nodeName: string | null, node: any) => {
  // eslint-disable-next-line
  const nextNodeIteration = (node: any) => {
    const keys = Object.keys(node).filter(
      (k) => (k !== '$$$parentNode' && k !== '$$$nodeName' && k !== 'condition'),
    );
    keys.forEach((key) => {
      if (isArray(node[key]) || isObject(node[key])) {
        addObjectParentReferences(node, key, node[key]);
      }
    });
  };

  // eslint-disable-next-line
  node.$$$nodeName = nodeName;
  // eslint-disable-next-line
  node.$$$parentNode = parent;

  if (isArray(node)) {
    node.forEach((e, index) => {
      e.$$$nodeName = `[${index}]`;
      e.$$$parentNode = node;
      nextNodeIteration(e);
    });
  } else {
    nextNodeIteration(node);
  }
};
